<div class="h-32 overflow-y-auto text-gray-600 italic">
  @for (item of legalTextData().text; track $index) {
    <p>
      @for (part of parseText(item); track $index) {
        @if (!isLink(part)) {
          {{ part }}
        } @else {
          <a [href]="part?.href" [target]="part?.target">{{ part?.text }}</a>
        }
      }
    </p>
    <br />
  }
</div>
